import { CmsHtml } from '../CmsHtml/CmsHtml.client';
import type { ServiceLayerElement } from './types';

export type ServiceLayerItemProps = {
  /** json data used to render banner */
  serviceLayerData: ServiceLayerElement[];
};

/**
 * This component displays Service Layer Content on Product Detailview Pages
 *
 * @param serviceLayerData Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const ServiceLayerItem = ({ serviceLayerData }: ServiceLayerItemProps) => (
  <div className="_c_cms_servicelayer">
    {serviceLayerData?.map((item, index) => (
      // The unique key is important from a performance point of view so that React doesn't have to render everything.
      // In this case it doesn't matter if only index or key is passed. The list is as it is and done.
      // eslint-disable-next-line @eslint-react/no-array-index-key
      <CmsHtml key={index} data={item.field_paragraph} />
    ))}
  </div>
);
